import React from 'react';
import { FormGroup, Label, Input } from 'reactstrap';
import { TICKET_STATUS_OPTIONS } from '../../constants/ticketStatuses';

export default function StatusFilter({ value = [], onChange }) {
  const handleChange = (e) => {
    const selected = Array.from(e.target.selectedOptions, (option) => option.value);
    onChange(selected);
  };

  return (
    <FormGroup className="mb-0">
      <Label className="col-form-label" for="status-filter">
        Status
      </Label>
      <Input
        id="status-filter"
        type="select"
        multiple
        className="form-select"
        style={{ minWidth: 220 }}
        value={value}
        onChange={handleChange}
        aria-label="Filter by status"
      >
        {TICKET_STATUS_OPTIONS.map((s) => (
          <option key={s} value={s}>
            {s}
          </option>
        ))}
      </Input>
    </FormGroup>
  );
}
